export default {
    "entityName": "protocol_has_site",
    "entityNameLabel": "Protocol site",
    "title": "Protocol sites",
    id: ['protocol_id', 'site_id'],
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "protocol.name",
        "descending": false
    },
    filterStorage: {},
    "fields": [
        {
            value: "_provider",
            visible: false,
            deps: ['protocol_id'],
            default: (item, args, selected) => selected && selected.provider
        },
        {
            full:true,
            "value": "protocol_id",
            "text": "Protocol",
            title: "name",
            subtitle: item => `${item.provider}`,
            "type": "autocomplete",
            filter: (item, search) => { return { "protocol.name": `%${search}%`} }, //"protocol.sponsor_id" : -1, //issue 203... tolto !
            "table": {
                "sortable": true,
                filter: true
            },
            render: item => `${item.protocol.name}`,
            validators: ['required'],
        },
        {
            full:true,
            "value": "site_id",
            "text": "Site",
            title: "factor_label",
            subtitle: item => `${item.city} - ${item.country_code}`,
            "type": "autocomplete",
            // filter: (item, search) => [{ 'site.name': `%${search}%`}, {'site.city': `%${search}%`}, {'site.code': `%${search}%`}],
            filter: (item, search) => [{ 'site.factor_label': `%${search}%`}],
            "table": {
                "sortable": true,
                filter: true
            },
            render: item => `${item.site.factor_label}`,
            validators: ['required'],
        },
        {
            full:true,
            value:'code',
            text:'Code',
            readonly: item => item._provider == 'REDCap' || !item.site_id || (item.protocol && item.protocol.provider == 'REDCap'),
            default: (item, args, selected) => selected && selected.code,
            deps:['_provider', 'site_id'],
            "table": {
                "sortable": true,
                filter: true
            },
            "validators": [
                "required",
            ]
        },
    ],
    "actions": [
        { "value": "upsert", "text": "Upsert", "icon": "mdi-pencil", "color": "primary", "disable" : (item) => { return item.protocol.map_name} },
        { "value": "remove", "text": "Remove", "icon": "mdi-delete", "color": "primary", "disable" : (item) => { return item.protocol.map_name} },
        "audit_trail","upsert","remove"
    ]
}